<template lang="pug">
    v-menu(dense v-model="datebox" :close-on-content-click="false" )
        template(v-slot:activator="{ on }")
          v-text-field(class="center-component" v-if="!template" readonly :value="formatDate" v-on="readonly ? '' : on" :label="label" dense append-icon="mdi-calendar" :rules="rules" :required="required")
          v-text-field(class="center-component" v-if="template" readonly :value="formatDate" v-on="readonly ? '' : on" :label="label" dense :rules="rules" :required="required")
              template(v-slot:prepend v-if="template")
                v-icon(color="primary") mdi-calendar
        v-date-picker(dense v-model="date" @change="onSelect" locale="id")
        
</template>
<script>
import moment from "moment";
export default {
  name: "FDateBox",
  props: ["value", "readonly", "label",  "template", "rules", "required"],
  data() {
    return {
      date: null,
      datebox: false
    };
  },
  mounted() {
    this.date = this.value;
  },
  watch: {
    value(val) {
      this.date = val;
    }
  },
  computed: {
    formatDate() {
      return this.date ? moment(this.date).format("DD-MM-YYYY") : "";
    }
  },
  methods: {
    onSelect() {
      this.$emit("input", this.date);
      this.$emit("select", this.date);
      this.$emit("change", this.date);
      this.datebox = false;
    }
  }
};
</script>
